module.exports = __webpack_public_path__ + "img/1591082004.9943d7dd.jpg";